<div class="routing-rule-actions routing-rule-settings">
  <div class="source-data-container">
    <div class="routing-rule-routing-method">
      <ac-input-container class="routing-method" label="Routing method">
        <ac-select class="single-row"
                   [(acModel)]="rule.routingMethod"
                   [items]="routingMethodOptions"
                   [bindLabel]="'label'"
                   [bindValue]="'value'">
        </ac-select>
      </ac-input-container>

      <div class="no-answer-timeout" >
        <mat-checkbox *ngIf="rule.routingMethod === 'seq'" name="enableDate" color="primary" [(ngModel)]="rule.isNoAnswerTimeoutEnable"></mat-checkbox>

        <mat-form-field class="fullWidth" *ngIf="rule.routingMethod === 'seq'">
          <mat-label>No answer timeout (sec)</mat-label>
          <input matInput type="number" [disabled]="!rule.isNoAnswerTimeoutEnable"
                 [(ngModel)]="rule.noAnswerTimeout" min="1" max="3600" name="isNoAnswerTimeoutEnable">
        </mat-form-field>
      </div>
      <div class="actions-buttons">
        <eco-fab-speed-dial direction="left" open="true">
          <eco-fab-speed-dial-trigger>
            <button mat-fab color="primary" title="Add"><mat-icon>post_add</mat-icon></button>
          </eco-fab-speed-dial-trigger>

          <eco-fab-speed-dial-actions>
            <button mat-mini-fab color="primary" (click)="addRegisteredUserAction()"
                    [disabled]="isRegisteredUserActionDefined()" title="Route to user location"><mat-icon>groups</mat-icon></button>
            <button mat-mini-fab color="primary" (click)="addDiscardAction()" title="Add discard action"
                    [disabled]="isDiscardOrContinueActionDisable()"><mat-icon>not_interested</mat-icon></button>
            <button mat-mini-fab color="primary" (click)="addContinueAction()" title="Add stop ARM routing action"
                    [disabled]="isDiscardOrContinueActionDisable()"><mat-icon>output</mat-icon></button>
            <button mat-mini-fab color="primary" (click)="addLoopbackAction()"
                    [disabled]="isLoopbackActionDisable()" title="Loopback"><mat-icon>loopback</mat-icon></button>
            <button mat-mini-fab color="primary" (click)="addAction()"
                    title="Add action"><mat-icon>add</mat-icon></button>
          </eco-fab-speed-dial-actions>
        </eco-fab-speed-dial>
      </div>
    </div>

    <div class="routing-actions-container">
      <p [ngClass]="{ 'error': !isValid }" class="rule-actions-notice"
         *ngIf="rule.action.actions.length === 0">Routing rule must have at least one action</p>
      <div class="action-accordion-container" [ngClass]="{'sequence': rule.routingMethod === 'seq'}">
        <mat-accordion class="action-list">
          <mat-expansion-panel *ngFor="let action of rule.action.actions; let ruleActionIndex=index" [expanded]="action.isOpen" (click)="selectHandler(action)">
            <mat-expansion-panel-header class="expansion-panel-header" expandedHeight="40px" collapsedHeight="40px" [ngClass]="{'selected': isSelected(action)}">
              <mat-panel-title class="action-title">
                <div title="{{action.title}}">{{action.title}}</div>
              </mat-panel-title>
              <button (click)="moveUpAction(ruleActionIndex)" [disabled]="isFirst(ruleActionIndex) || isDiscardOrContinueActionSelected(ruleActionIndex)"
                      color="primary" mat-icon-button title="Move up">
                <mat-icon>arrow_upward</mat-icon>
              </button>
              <button (click)="moveDownAction(ruleActionIndex)" [disabled]="isLast(ruleActionIndex) || isDiscardOrContinueActionSelected(ruleActionIndex)"
                      mat-icon-button title="Move down" color="primary">
                <mat-icon>arrow_downward</mat-icon>
              </button>
              <button (click)="removeAction(ruleActionIndex)"
                      mat-icon-button title="Remove action" class="delete-action">
                <mat-icon>delete</mat-icon>
              </button>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              <div class="single-action not-discard" *ngIf="!action.actions[0].discard">
                <div class="load-balancing-tools-container">
                  <div *ngIf="action.actions.length > 1" class="equally-balance-checkbox-container">
                    <mat-checkbox name="isEquallyBalanced" color="primary" [(ngModel)]="action.isEquallyBalanced"
                                  (change)="handleBalancingCheckboxChange(action)">Equally Balance</mat-checkbox>
                  </div>

                  <div *ngIf="action.actions.length > 1" class="routing-attempts-container">
                    <mat-form-field class="fullWidth">
                      <mat-label>Routing Attempts</mat-label>
                      <input matInput type="number" (change)="updateRoutingAttemptsInAllInnerActions(action.actions)"
                             [(ngModel)]="action.actions[0].routingAttempts" min="1" [max]="action.actions.length" name="isNoAnswerTimeoutEnable">
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <div class="single-action discard" *ngIf="action.actions[0].discard">
                <mat-radio-group class="radio-option" [(ngModel)]="action.actions[0].isSipReasonDefined"
                                 [ngModelOptions]="{standalone: true}" (change)="onSipReasonChange($event)">
                  <div class="radio-options">
                    <mat-radio-button color="primary" [value]="false" class="fullWidth">
                      Use default SIP reason
                    </mat-radio-button>

                    <mat-radio-button color="primary" [value]="true" class="fullWidth">
                      <div class="discard-sip-reason">
                        <mat-form-field class="fullWidth">
                          <mat-label>SIP reason</mat-label>
                          <input matInput [(ngModel)]="action.actions[0].sipReason" type="number" min="1" max="610" name="incomingLimit"
                                 [disabled]="!action.actions[0].isSipReasonDefined">
                        </mat-form-field>
                      </div>
                    </mat-radio-button>
                  </div>
                </mat-radio-group>
              </div>

              <div class="single-action registered-users" *ngIf="action.actions[0].registeredUsers">
                <label>Route the call to one of the Peer Connections of the registered user</label>
              </div>

              <div class="single-action registered-users" *ngIf="action.actions[0].continueWithNodeInternalTables">
                <label>Stop ARM routing and continue with node`s internal routing table</label>
              </div>

              <div class="single-action registered-users" *ngIf="action.actions[0].loopback">
                <div class="normalization-after-routing">
                  <div class="loopback-normalization-source">
                    <ac-input-container label="Source URI User">
                      <ac-select [(acModel)]="action.actions[0].srcNormalizationGroup"
                                 [items]="normalizationGroup"
                                 [bindValue]="'id'"
                                 [bindLabel]="'groupName'"
                                 [allowClear]="true"
                                 width="260">
                      </ac-select>
                    </ac-input-container>

                    <div class="source-uri-normalization-options">
                      <mat-checkbox name="isEquallyBalanced" color="primary"
                                    [(ngModel)]="action.actions[0].srcNormalizationFromHeader"
                                    [disabled]="!action.actions[0].srcNormalizationGroup">
                        From
                      </mat-checkbox>
                      <mat-checkbox name="isEquallyBalanced" color="primary"
                                    [(ngModel)]="action.actions[0].srcNormalizationPAIHeader"
                                    [disabled]="!action.actions[0].srcNormalizationGroup">
                        PAI
                      </mat-checkbox>
                      <mat-checkbox name="isEquallyBalanced" color="primary"
                                    [(ngModel)]="action.actions[0].srcNormalizationPPIHeader"
                                    [disabled]="!action.actions[0].srcNormalizationGroup">
                        PPI
                      </mat-checkbox>
                    </div>
                  </div>

                  <div class="normalization-destination">
                    <ac-input-container label="Destination URI User">
                      <ac-select [(acModel)]="action.actions[0].destNormalizationGroup"
                                 [items]="normalizationGroup"
                                 [bindValue]="'id'"
                                 [bindLabel]="'groupName'"
                                 [allowClear]="true"
                                 width="260">
                      </ac-select>
                    </ac-input-container>

                    <ac-input-container label="SIP Manipulation Group">
                      <ac-select [(acModel)]="action.actions[0].sipManipulationGroupId"
                                 [items]="sipManipulationGroups"
                                 [bindValue]="'id'"
                                 [bindLabel]="'name'"
                                 [allowClear]="true"
                                 width="260">
                      </ac-select>
                    </ac-input-container>
                  </div>
                </div>
              </div>

              <div class="single-action not-discard" *ngIf="!action.actions[0].discard && !action.actions[0].registeredUsers &&
              !action.actions[0].continueWithNodeInternalTables && !action.actions[0].loopback">

                <div class="single-balanced-action" *ngFor="let subAction of action.actions; let index=index; let last=last;">

                  <div class="basic-selection-container">
                    <div class="percentage">
                      <ng-container *ngIf="!action.isEquallyBalanced && action.actions.length > 1">
                        <mat-form-field>
                          <input type="number" [(ngModel)]="subAction.percentage" matInput
                                 min="1" max="99" required
                                 [name]="'limit' + index + '-' + ruleActionIndex" (change)="isEquallyBalancedValid()"
                                 [errorStateMatcher]="errorStateMatcher">
                          <mat-error>Invalid</mat-error>
                          <span matSuffix>%</span>
                        </mat-form-field>
                      </ng-container>
                    </div>
                    <ac-input-container class="combined" [customError]="!subAction.combined ? 'Element is required' : null" [required]="true">
                      <ac-select [(acModel)]="subAction.combined"
                                 (acModelChange)="updateActionMainTitle($event, subAction); updateMap(subAction); setMaxResourceAttemptsValue(subAction)"
                                 [items]="combinedOptions"
                                 [bindValue]="undefined"
                                 [bindLabel]="'name'"
                                 [groupBy]="'elementType'"
                                 name="combined"
                                 [displayImage]="true"
                                 [attr.alternativeName]="'combined-' + ruleActionIndex.toString() + '-' + index.toString()">
                      </ac-select>
                    </ac-input-container>

                    <div class="combined-actions">
                      <button class="combined-action" title="Delete"
                              [disabled]="action.actions.length === 1" mat-icon-button color="primary"
                              (click)="removeRuleAction(action, subAction); isEquallyBalancedValid()">
                        <mat-icon class="icons-inner">delete</mat-icon>
                      </button>

                      <button mat-icon-button color="primary" class="combined-action" title="Select from map"
                              nz-popover nzPopoverTrigger="click" [nzPopoverContent]="contentTemplate" (click)="mapFocus(action, subAction)">
                        <mat-icon class="icons-inner">pin_drop</mat-icon>
                      </button>

                      <ng-template #contentTemplate>
                        <div style="height: 580px; width: 800px">
                          <choose-topology-item-container [diagramId]="'routing-rule-actions'"
                                                          [options]="mapOptions"
                                                          (onClick)="onMapClick($event)">
                          </choose-topology-item-container>
                        </div>
                      </ng-template>

                      <button mat-icon-button color="primary" class="combined-action add-load-balancing-button" *ngIf="last"
                              (click)="addNewRuleAction(action); isEquallyBalancedValid()" title="Add load balancing">
                        <mat-icon class="icons-inner">add</mat-icon>
                      </button>
                    </div>

                    <span class="via-nodes" *ngIf="subAction.viaNodes && !isTopologyGroup(subAction.combined)"> via </span>

                    <ac-input-container class="forAuxilary" *ngIf="subAction.viaNodes && !isTopologyGroup(subAction.combined)">
                      <ac-select [(acModel)]="subAction.viaNodes"
                                 [items]="rule.adminState === 'LOCKED' ? nodesOnlyWithoutThirdPartyWithOffline : nodesOnlyWithoutThirdParty"
                                 [bindLabel]="'name'"
                                 [bindValue]="'id'"
                                 [groupBy]="'elementType'"
                                 [allowClear]="true"
                                 [ngDisabled]="isSelectedCombinedIsVoipPeer(subAction)">
                      </ac-select>
                    </ac-input-container>

                    <div *ngIf="isTopologyGroup(subAction.combined)" class="resource-attempts-container">
                      <ac-input-container label="Resource attempts" class="resource-attempts-input">
                        <ac-num-spinner [(acModel)]="subAction.attemptsInTopologyGroup"
                                        [minValue]="1"
                                        [maxValue]="resourceAttemptsMaxValue(subAction)"
                                        (acModelChange)="addAdditionalInformationToActions(rule.action.actions)">
                        </ac-num-spinner>
                      </ac-input-container>
                    </div>
                  </div>

                  <div class="resource-attempts-error-message" *ngIf="subAction.resourceAttemptsError" [innerHTML]="subAction.resourceAttemptsError"></div>

                  <div class="normalization-after-routing-container">
                    <div (click)="subAction.isNormalizationCollapsed = !subAction.isNormalizationCollapsed" class="normalization-after-routing-title">
                      <i class="fa fa-angle-right fa-lg collapse-arrow" *ngIf="subAction.isNormalizationCollapsed"></i>
                      <i class="fa fa-angle-down fa-lg collapse-arrow" *ngIf="!subAction.isNormalizationCollapsed"></i>
                      <span> Advanced</span>
                    </div>

                    <div class="normalization-after-routing-content" *ngIf="!subAction.isNormalizationCollapsed">
                      <div class="normalization-after-routing">
                        <ac-line-separator title="Normalization After Routing"></ac-line-separator>

                        <div class="normalization-source">
                          <ac-input-container label="Source URI User">
                            <ac-select [(acModel)]="subAction.srcNormalizationGroup"
                                       [items]="normalizationGroup"
                                       [bindValue]="'id'"
                                       [bindLabel]="'groupName'"
                                       [allowClear]="true"
                                       width="260">
                            </ac-select>
                          </ac-input-container>

                          <div class="source-uri-normalization-options">
                            <mat-checkbox name="isEquallyBalanced" color="primary"
                                          [(ngModel)]="subAction.srcNormalizationFromHeader"
                                          [disabled]="!subAction.srcNormalizationGroup">
                              From
                            </mat-checkbox>
                            <mat-checkbox name="isEquallyBalanced" color="primary"
                                          [(ngModel)]="subAction.srcNormalizationPAIHeader"
                                          [disabled]="!subAction.srcNormalizationGroup">
                              PAI
                            </mat-checkbox>
                            <mat-checkbox name="isEquallyBalanced" color="primary"
                                          [(ngModel)]="subAction.srcNormalizationPPIHeader"
                                          [disabled]="!subAction.srcNormalizationGroup">
                              PPI
                            </mat-checkbox>
                          </div>
                        </div>

                        <div class="normalization-destination">
                          <ac-input-container label="Destination URI User">
                            <ac-select [(acModel)]="subAction.destNormalizationGroup"
                                       [items]="normalizationGroup"
                                       [bindValue]="'id'"
                                       [bindLabel]="'groupName'"
                                       [allowClear]="true"
                                       width="260">
                            </ac-select>
                          </ac-input-container>

                          <ac-input-container label="SIP Manipulation Group">
                            <ac-select [(acModel)]="subAction.sipManipulationGroupId"
                                       [items]="sipManipulationGroups"
                                       [bindValue]="'id'"
                                       [bindLabel]="'name'"
                                       [allowClear]="true"
                                       width="260">
                            </ac-select>
                          </ac-input-container>
                          <mat-checkbox name="isEquallyBalanced" color="primary" [(ngModel)]="subAction.customerNormalizationSIPHeader"
                                        [disabled]="isCustomerNormalizationDisabled(subAction)">
                            Use contact host from destination customer
                          </mat-checkbox>
                        </div>
                      </div>

                      <div class="request-uri">
                        <ac-line-separator title="Request URI"></ac-line-separator>

                        <div class="normalization-source">
                          <mat-checkbox name="isEquallyBalanced" color="primary" class="dest-type-request-uri" [(ngModel)]="subAction.destTypeRequestUri"
                                        [disabled]="isDestTypeRequestUriDisabled(subAction)"
                                        (change)="handleBalancingCheckboxChange(action)">
                            Route based on request URI
                          </mat-checkbox>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
  </div>
</div>
